document.addEventListener('DOMContentLoaded', () => {
  let previousScrollY = window.scrollY;
  const stickyNav = () => {
    const currentScrollY = window.scrollY;
    const header = document.querySelector('.header-wrapper');
    const stickyFacets = document.querySelector('.facets-wrapper');
    document.documentElement.style.setProperty('--header-height', `${header?.offsetHeight}px`);

    if (currentScrollY > previousScrollY) {
      document.body.classList.add('hide-annoucement-bar');
    } else {
      document.body.classList.remove('hide-annoucement-bar');
    }

    if (currentScrollY > 0) {
      document.body.classList.add('is-header-stuck');
    } else {
      document.body.classList.remove('is-header-stuck');
    }

    previousScrollY = currentScrollY;

    // detect and update facets container class
    if(stickyFacets) {
      const headerHeight = parseInt(getComputedStyle(stickyFacets).getPropertyValue('--header-height').trim());
      if((stickyFacets.getBoundingClientRect().top) <= headerHeight - 1) {
        stickyFacets.classList.add('is-sticky');
      } else {
        stickyFacets.classList.remove('is-sticky');
      }
    }
  }

  stickyNav();
  window.addEventListener('scroll', stickyNav);

  const items = document.querySelectorAll('.header-nav__item');
  const navs = document.querySelectorAll('.header__nav');

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => openMenu(item));
    const links = item.querySelectorAll('.header-nav__item-link, .header-subnav__item-link');

    links.forEach((link) => {
      link.addEventListener('focus', () => openMenu(item));
      link.addEventListener('focusout', (event) => {
        if (event.relatedTarget &&
          !event.relatedTarget.closest('.header-nav__item')
        ) {
          closeAllMenus();
        }
      });
    })
  })

  navs.forEach((nav) => {
    nav.addEventListener('mouseout', (event) => {
      if (!event.relatedTarget || event.relatedTarget.closest('.header-nav__item') === null || event.relatedTarget.closest('.header__nav') != nav) {
        closeAllMenus();
      }
    });
  });

  function openMenu(activeItem) {
    items.forEach((item) => {
      const itemLink = item.querySelector(':scope > .header-nav__item-link');

      if (itemLink) {
        if (item === activeItem) {
          itemLink.setAttribute('aria-expanded', 'true');
        } else {
          itemLink.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  function closeAllMenus() {
    openMenu(null);
  }
});

/* update header height variable value once on full page load with interval to prevent on page load 
 scroll issues for header/facets (only for collection and search pages)*/
 if(window.location.href.includes('/collections/') || window.location.href.includes('search?q=')) {
  window.addEventListener('load', () => {
    const header = document.querySelector('.header-wrapper');
    setTimeout(() => {
      document.documentElement.style.setProperty('--header-height', `${header?.offsetHeight}px`);
    }, 600)
  })
}